import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Card, Avatar, Input, Image, Modal, Button, Menu, Col, Row, message, Space, Popover, Tab, Carousel } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { EditOutlined, FolderOpenOutlined, UserOutlined, MoreOutlined, HistoryOutlined } from '@ant-design/icons';
const { Search } = Input;
const FileFolderCard = (props) => {
    // const [color, setColor] = useState(['#9596CC', '#AAC6D8', '#a8c69f', '#cce2a3', '#C98CE6', '#586994', '#7D869C', '#B4C4AE', '#6D696A', '#A2A7A5', '#E9D8A6', '#F7EDE2', '#F5CAC3', '#84A59D', '#293241', '#6D597A', '#B56576', '#E56B6F', '#EAAC8B', '#D68C45', '#C8553D'])
    const navigate = useNavigate();
    return (
        <>
            {props.data && props.data.map((item, i) => (<>

                <Col md={8} sm={24} >
                    <Row gutter={[8, 16]} justify={'space-between'} style={{ padding: '20px', backgroundColor: item.background_color || '#AAC6D8', color: item.font_color || 'white', borderRadius: '15px', cursor: 'pointer' }} >
                        <Col span={20} onClick={e => navigate(`/cramSchool/admin/Media/Content/${item.classify_structure_type_id}`)}>
                            <FolderOpenOutlined style={{ fontSize: '1.2rem' }} />
                        </Col>
                        <EditOutlined
                            className='example'
                            style={{
                                backgroundColor: '#F9D4E5',
                                fontSize: '1.2rem',
                                borderRadius: '50%',
                                padding: '8px',
                                zIndex: 99,
                                color: 'black',
                                position: 'absolute',
                                right: '-5px',
                                top: '-10px'
                            }}
                            onClick={e => props.handleOnEdit(item.classify_structure_type_id)}
                        />
                        <Col span={24} onClick={e => navigate(`/cramSchool/admin/Media/Content/${item.classify_structure_type_id}`)}>
                            <Row gutter={[8, 16]}>
                                <Col span={24} style={{ fontSize: '1.2rem' }} onClick={e => navigate(`/cramSchool/admin/Media/Content/${item.classify_structure_type_id}`)}>
                                    {item.name}
                                </Col>
                                <Col span={24} style={{ fontSize: '1rem' }} onClick={e => navigate(`/cramSchool/admin/Media/${i}`)}>
                                    {item.file_total}個檔案,{item.folder_total}個資料夾
                                </Col>
                                {/* <Col span={24} style={{ fontSize: '0.8rem' }} onClick={e => navigate(`/cramSchool/admin/Media/${i}`)}>
                                    最近修改時間： 2023-12-11
                                </Col> */}
                            </Row>
                        </Col>
                    </Row>
                </Col >

            </>))
            }
        </>
    )
}
export default FileFolderCard;